import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import CdisbSummaryDetails from "../details/CdisbSummaryDetails";
import ViewPdf from "../components/ViewPdf";

import RunIcon from "@material-ui/icons/PlayArrowOutlined";
import PrintIcon from "@material-ui/icons/PrintOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  customFont: {
    fontSize: 12,
  },
});

class AggregatedCdisbSummaryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      reports: [],
      accounts: [],
      checkAll: true,
      searchOk: false,
      viewPdf: false,
      viewPopup: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }

  componentDidMount() {
    fetch("on_company_report_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accounts: this.props.prefs.accounts,
        reportType: "CDISB",
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          if (reply.accounts.length === 0) {
            this.setState({
              notifyString:
                "No accounts configured for " +
                this.props.option.descr +
                " report",
            });
            this.setState({ viewPopup: true });
          } else {
            let accounts = [];
            let i;
            for (i = 0; i < reply.accounts.length; i++) {
              accounts.push({
                index: i,
                info: reply.accounts[i],
                checked: true,
              });
            }
            this.setState({ accounts: accounts });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleCheckAll(e) {
    let checkAll = !this.state.checkAll;
    let items = this.state.accounts;
    let i;
    for (i = 0; i < items.length; i++) {
      items[i].checked = checkAll;
    }
    this.setState({ checkAll: checkAll });
    this.setState({ accounts: items });
    this.setState({ searchOk: false });
  }

  handleCheckItem(event, index) {
    let items = this.state.accounts;
    items[index].checked = !items[index].checked;
    this.setState({ accounts: items });
    this.setState({ searchOk: false });
  }

  handleSearch(e) {
    let checkedAccounts = this.getCheckedAccounts();
    if (checkedAccounts.length === 0) {
      this.setState({
        errorString:
          "All accounts are unchecked. At least one account is required",
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.search(checkedAccounts);
  }

  handleSearchPDF(e) {
    let checkedAccounts = this.getCheckedAccounts();
    if (checkedAccounts.length === 0) {
      this.setState({
        errorString:
          "All accounts are unchecked. At least one account is required",
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ viewPdf: true });
    //this.searchPDF(checkedAccounts);
  }

  getCheckedAccounts() {
    let checkedAccounts = [];
    let accounts = this.state.accounts;
    let i;
    for (i = 0; i < accounts.length; i++) {
      if (accounts[i].checked) {
        checkedAccounts.push(accounts[i].info);
      }
    }
    return checkedAccounts;
  }

  handlePrint(e) {
    var prtContent = document.getElementById("myReport");
    var winPrint = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0"
    );
    winPrint.document.write(prtContent.innerHTML);
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    winPrint.close();
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  search(accounts) {
    this.setState({ searchOk: false });
    this.setState({ reports: [] });
    var accountsList = {};
    accountsList.secureToken = this.props.secureToken;
    accountsList.accounts = accounts;
    fetch("on_aggregated_cdisb_summary_request", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountsList),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ report: reply });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else if (reply.reports.length > 0) {
            this.setState({ reports: reply.reports });
            this.setState({ searchOk: true });
          } else {
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
            this.setState({ viewPopup: true });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  getSearchObject() {
    let checkedAccounts = this.getCheckedAccounts();
    let data = {
      accounts: checkedAccounts,
      secureToken: this.props.secureToken,
    };
    return data;
  }

  render() {
    const { classes } = this.props;
    let options = this.props.reports;
    let myPdfUrl = "on_aggregated_cdisb_summary_pdf_request";
    let { t } = this.props;
    return (
      <div>
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            postData={this.getSearchObject()}
            pdfUrl={myPdfUrl}
            report={this.state.report}
            nopagination="yes"
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        <div>
          <Paper elevation={5}>
            <div
              style={{ display: "flex", flexDirection: "row", marginTop: 10 }}
            >
              <div style={{ marginLeft: 10 }}>
                <Typography variant="caption">
                  {t("aggregatedReport.label")}&nbsp;&nbsp;
                </Typography>
                <FormControl>
                  <NativeSelect
                    style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                    defaultValue={this.props.option.type}
                    input={<Input id="report_options" />}
                    onChange={(event) => this.handleChange(event)}
                  >
                    {options.map((n) => {
                      return (
                        <option key={n.type} value={n.type}>
                          {n.descr}
                        </option>
                      );
                    })}
                  </NativeSelect>
                </FormControl>
              </div>
              {this.state.accounts.length > 0 && (
                <div
                  style={{
                    marginLeft: 40,
                    marginTop: 20,
                    height: 120,
                    width: "40%",
                    overflow: "auto",
                  }}
                >
                  <Table style={{ border: "0px solid" }} stickyHeader>
                    <TableHead>
                      <TableRow style={{ height: 30 }}>
                        <TableCell padding="none">
                          <Checkbox
                            style={{ height: 15 }}
                            checked={this.state.checkAll === true}
                            onChange={(event) => this.handleCheckAll(event)}
                            value="0"
                            color="default"
                          />
                        </TableCell>
                        <TableCell>{t("transit.header")}</TableCell>
                        <TableCell>{t("account.header")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.accounts.map((item) => {
                        return (
                          <TableRow key={item.index} style={{ height: 30 }}>
                            <TableCell padding="none">
                              <Checkbox
                                style={{ height: 15 }}
                                checked={item.checked === true}
                                onChange={(event) =>
                                  this.handleCheckItem(event, item.index)
                                }
                                value={"" + item.index}
                                color="default"
                              />
                            </TableCell>
                            <TableCell className={classes.customFont}>
                              {item.info.transit}
                            </TableCell>
                            <TableCell className={classes.customFont}>
                              {item.info.account}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              )}
              {this.state.accounts.length > 0 && (
                <div style={{ marginLeft: 50, marginTop: 20 }}>
                  <Tooltip
                    title={t("showReportFor.tip") + this.props.option.descr}
                  >
                    <Button
                      color="primary"
                      onClick={(event) => this.handleSearch(event)}
                    >
                      <RunIcon />
                      &nbsp;{t("run.button")}
                    </Button>
                  </Tooltip>
                </div>
              )}
              {this.state.searchOk && (
                <div style={{ marginLeft: 10, marginTop: 20 }}>
                  <Tooltip title={t("printReport.tip")}>
                    <Button
                      color="primary"
                      onClick={(event) => this.handlePrint(event)}
                    >
                      <PrintIcon />
                      &nbsp;{t("printReport.tip")}
                    </Button>
                  </Tooltip>
                </div>
              )}
              {this.state.accounts.length > 0 && (
                <div style={{ marginLeft: 50, marginTop: 20 }}>
                  <Tooltip
                    title={t("showPdfReportFor.tip") + this.props.option.descr}
                  >
                    <Button
                      color="primary"
                      onClick={(event) => this.handleSearchPDF(event)}
                    >
                      <PDFViewIcon />
                      &nbsp;{t("pdf.button")}
                    </Button>
                  </Tooltip>
                </div>
              )}
            </div>
            <div>&nbsp;&nbsp;</div>
          </Paper>
        </div>
        {this.state.searchOk && (
          <div id="myReport">
            {this.state.reports.map((item, index) => {
              return (
                <div>
                  {index > 0 && (
                    <div style={{ pageBreakBefore: "always" }}></div>
                  )}
                  <CdisbSummaryDetails report={item} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(
  withStyles(styles)(AggregatedCdisbSummaryPage)
);
